import * as React from 'react';
import { useHistory } from "react-router-dom";
import axios, { CancelTokenSource } from 'axios';
import themePrimary from '../../styles/themePrimary';
import { useMediaQuery, Typography, makeStyles } from '@material-ui/core';
import { WebCheckOutResponse } from '../../models/checkout/WebCheckOutResponse';
import { CheckOutState, CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import SplitButtons, { SplitButtonProps } from '../common/Buttons/SplitButtons';
import { getUrlParameter } from '../../utilities/UrlHelper';
import { WebCheckOutRequest } from '../../models/checkout/WebCheckOutRequest';
import ErrorDialog, { ErrorDialogProps } from '../common/ErrorDialog';
import { String_CheckOut_Instruction_Sub, String_System_GeneralError, String_System_ConnectionError, 
    String_CheckOut_Instruction, String_CheckOut_PhoneLabel, 
    String_CheckOut_TableLabel, String_System_Cancel, String_CheckOut_CheckOutButton, String_CheckOut_ViewMenuButton, 
    String_CheckOut_NoOpenChecks_TextToPay, String_CheckOut_NoOpenChecks_ScanToPay, 
    String_CheckOut_NoOpenChecks_ScanReceiptToPay,
    String_CheckOut_FeedbackButton,
    String_CheckOut_Instruction_With_Feedback,
    String_CheckOut_Instruction_Sub_With_Feedback} from '../../utilities/StringHelper';
import { FormatPhoneNumber } from '../../utilities/PhoneHelper'
import Loader from '../common/Loader'
import { ElementDimensions } from '../../styles/ElementDimensions';
import FullWidthButton, { FullWidthButtonProps, FullWidthButtonSize } from '../common/Buttons/FullWidthButton';
import LogoImage from '../../images/logo_footer.png'
import DemoMenu from '../../images/demo_menu.png'
import { CheckOutType } from '../../models/common/CheckOutType';
import { UserState, UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckSummary } from '../../models/common/CheckSummary';
import SignalR, { CheckMessageType, CheckNotificationType } from '../common/SignalR';
import { useCookies } from 'react-cookie';
import { SplitType } from '../../models/common/SplitType';
import { CheckStateContext, CheckState } from '../../providers/CheckStateContextProvider';
import { PaymentGateway } from '../../models/common/PaymentGateway';
import { ErrorCode } from '../../models/common/ErrorCode';
import { PaymentGatewayConnector } from '../../models/common/PaymentGatewayConnector';
import { PMSType } from '../../models/common/PMSType';
import { isNullOrUndefined } from 'util';
import { FeedbackType } from '../../models/common/FeedbackType';
import { GetLocationResponse } from '../../models/checkout/GetLocationResponse';
import { Location } from '../../models/checkout/Location';
import { LocationConfiguration } from '../../models/checkout/LocationConfiguration';
import { GetLocationByExternalIdRequest } from '../../models/checkout/GetLoactionByExternalIdRequest';
import { loadDemoCheckSummaryData } from '../../models/common/DemoData';

const useStyles = makeStyles({
    demoMenu: {
        width: '100%',
    },
    details: {
        position: 'absolute',
        top: (ElementDimensions.margin40 + ElementDimensions.appBarHeight) + 'px',
        bottom: ElementDimensions.footerBarHeightWithLogo + 'px',
        left: 0,
        right: 0,
        width: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    detailsLandscape: {
        position: 'absolute',
        top: (ElementDimensions.margin20) + 'px',
        bottom: ElementDimensions.footerBarHeightLandscape + 'px',
        left: 'calc(100vw *.3)',
        width: 'calc(100vw *.7)',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    detailsIFrame: {
        position: 'absolute',
        top: ElementDimensions.appBarHeight + 'px',
        bottom: ElementDimensions.footerBarHeightWithLogo + 'px',
        left: 0,
        right: 0,
        width: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    detailsIFrameLandscape: {
        position: 'absolute',
        top: '0px',
        bottom: ElementDimensions.footerBarHeightLandscape + 'px',
        left: 'calc(100vw *.3)',
        width: 'calc(100vw *.7)',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    footerButtons: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        height: ElementDimensions.footerBarHeightWithLogo + 'px',
        padding: ElementDimensions.padding10 + 'px ' + '0px ' + ElementDimensions.padding10 + 'px 0px',
        width: '100%',
        borderTop: '2px solid ' + themePrimary.palette.grey[200],
        backgroundColor: themePrimary.palette.primary.contrastText,
    },
    footerButtonsLandscape: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 'calc(100vw *.3)',
        height: ElementDimensions.footerBarHeightLandscape + 'px',
        padding: ElementDimensions.padding10 + 'px ' + '0px ' + ElementDimensions.padding10 + 'px 0px',
        width: 'calc(100vw * .7)',
        borderTop: '2px solid ' + themePrimary.palette.grey[200],
        backgroundColor: themePrimary.palette.primary.contrastText,
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    gridContainer: {
        display: 'flex',
        marginLeft: ElementDimensions.margin20 + 'px',
        marginRight: ElementDimensions.margin20 + 'px',
        marginBottom: ElementDimensions.margin20 + 'px',
    },
    instructionContainer: {
        textAlign: 'center',
        margin: '0px ' + ElementDimensions.margin10 + 'px ' + ElementDimensions.margin30 + 'px ' + ElementDimensions.margin10 + 'px',
    },
    instruction2Container: {
        textAlign: 'center',
        margin: ElementDimensions.margin30 + 'px ' + ElementDimensions.margin10 + 'px ' + ElementDimensions.margin30 + 'px ' + ElementDimensions.margin10 + 'px',
    },
    instructionText: {
      marginBottom: ElementDimensions.margin20 + 'px',
    },
    label: {
        textAlign: 'right',
        marginBottom: ElementDimensions.margin20 + 'px',
        paddingRight: ElementDimensions.padding10 + 'px',
    },
    loadingContainer: {
        margin: ElementDimensions.margin40 + 'px',
        textAlign: 'center',
    },
    logoContainer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        textAlign: 'center',
        paddingTop: ElementDimensions.padding10 + 'px',
        paddingBottom: ElementDimensions.padding10 + 'px',
    },
    menuIframe: {
        width: '100%',
        height: '100%',
        border: 'none',
    },
    root: {
        height: '100%',
    },
    rootLandscape: {
        height: '100%',
    },
    value: {
        textAlign: 'left',
        marginBottom: ElementDimensions.margin20 + 'px',
    },
});

const CheckOut = () => {
    const isPortrait = true;
    const [errorDialogOpen, setErrorDialogOpen] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>('');
    const [checkOut, setCheckout] = React.useState<boolean>(true);
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [loadError, setLoadError] = React.useState<boolean>(false);
    const [checkOutType, setCheckOutType] = React.useState<CheckOutType | null>(null);
    const [oldChecks, setOldChecks] = React.useState<CheckSummary[] | null>(null);
    const [checks, setChecks] = React.useState<CheckSummary[] | null>(null);
    const [signalRInitialized, setSignalRInitialized] = React.useState<boolean>(false);
    const [signalRLoad, setSignalRLoad] = React.useState<boolean>(false);
    const [cookies, setCookie] = useCookies(["user"]);
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const checkState = React.useContext(CheckStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });
    
    let history = useHistory();
    let checkInId: number | null = null;
    let isShare: boolean = false;
    let locale: string | undefined = undefined;
    let restaurantId: string | undefined = undefined;

    React.useEffect(() => {
        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();

        userState.setState(null);
        localStorage.clear();

        getLocation(source);
        
        return () => {
            source.cancel();
        };
    }, []);

    const getLocation = async (cancelTokenSource: CancelTokenSource) => {
        const restaurantIdParam = getUrlParameter(history.location.search, 'r');
        var restaurantExternalId: string | null = null;

        if (isNullOrUndefined(restaurantIdParam) || restaurantIdParam === "") {
            restaurantExternalId = getUrlParameter(history.location.search, 're');
            restaurantExternalId = decodeURI(restaurantExternalId);
            
            let url: string | undefined = process.env.REACT_APP_WEBAPP_API_URL + "/location";

            let request: GetLocationByExternalIdRequest = {
                location_external_id: restaurantExternalId
            };

            axios.post(url!!, request, { cancelToken: cancelTokenSource.token })
                .then(function(response) {
                    processGetLocationResponse(response.data as GetLocationResponse, cancelTokenSource)
                })
                .catch(function(error) {
                    if (error.response) {
                        setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                    }
                    else {
                        setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                    }

                    setErrorDialogOpen(true);
                    setLoadError(true);
                    setLoaded(true);
                });  
        }
        else {
            restaurantId = restaurantIdParam;

            let url: string | undefined = process.env.REACT_APP_WEBAPP_API_URL + "/location/" + restaurantId;

            axios.get(url!!, { cancelToken: cancelTokenSource.token })
                .then(function(response) {
                    processGetLocationResponse(response.data as GetLocationResponse, cancelTokenSource)
                })
                .catch(function(error) {
                    if (error.response) {
                        setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                    }
                    else {
                        setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                    }

                    setErrorDialogOpen(true);
                    setLoadError(true);
                    setLoaded(true);
                });      
        }
    }

    const processGetLocationResponse = (r: GetLocationResponse, cancelTokenSource: CancelTokenSource) => {
        const newUserState: UserState = userState.state;
        const newCheckOutState: CheckOutState = checkOutState.state;

        if (checkOutState.state.checks !== null && oldChecks === null) {
            setOldChecks(checkOutState.state.checks);
        }

        newCheckOutState.tableNumber = null;
        newCheckOutState.tableId = null;
        newCheckOutState.restaurantId = null;
        newCheckOutState.restaurantName = null;
        newCheckOutState.restaurantLocale = null;
        newCheckOutState.restaurantCurrency = null;
        newCheckOutState.restaurantCountry = null;
        newCheckOutState.applePayMerchantId = null;
        newCheckOutState.restaurantGooglePayMerchantId = null;
        newCheckOutState.restaurantGooglePayMerchantName = null;
        newCheckOutState.restaurantLogoUrl = null; 
        newCheckOutState.restaurantLoaderUrl = null; 
        newCheckOutState.checkOutType = null;
        newCheckOutState.checkInId = null;
        newCheckOutState.sentRating = false;
        newCheckOutState.digitalServiceFee = null;
        newCheckOutState.paymentGateway = PaymentGateway.Demo;
        newCheckOutState.paymentGatewayConnector = PaymentGatewayConnector.None;
        newCheckOutState.posType = null;
        newCheckOutState.pmsType = PMSType.None;
        newCheckOutState.stripeApiKey = null;
        newCheckOutState.stripeAccountId = null;
        newCheckOutState.spreedlyEnvKey = null;
        newCheckOutState.useCaptcha = false;
        newCheckOutState.feedbackType = FeedbackType.None;
        newCheckOutState.menuUrl = null;
        newCheckOutState.receiptCheckExternalId = null;

        checkOutState.setState(newCheckOutState);

        const newCheckState: CheckState = checkState.state;
        newCheckState.checkSummary = null;
        newCheckState.checkDetail = null;
        newCheckState.splitAmount = 0;
        newCheckState.splitType = SplitType.None;
        newCheckState.splitEvenlyCount = 0;
        newCheckState.splitPercentage = 0;
        newCheckState.paymentId = null;

        checkState.setState(newCheckState);

        if (r.success) {
            if (locale !== undefined) {
                newUserState.locale = locale
            }

            userState.setState(newUserState);

            newCheckOutState.restaurantId = r.location.id;
            newCheckOutState.restaurantName = r.location.name;
            newCheckOutState.restaurantLocale = r.location.locale;
            newCheckOutState.restaurantCurrency = r.location.currency;
            newCheckOutState.restaurantCountry = r.location.country;
            newCheckOutState.applePayMerchantId = r.location.configuration.apple_pay_merchant_id;
            newCheckOutState.restaurantGooglePayMerchantId = r.location.configuration.googlepay_merchantid;
            newCheckOutState.restaurantGooglePayMerchantName = r.location.configuration.googlepay_merchantname;
            newCheckOutState.restaurantLogoUrl = process.env.REACT_APP_IMAGE_URL + '/' + r.location.id.toUpperCase() + '.png'; 
            newCheckOutState.restaurantLoaderUrl = process.env.REACT_APP_LOADER_URL + '/' + r.location.id.toUpperCase() + '.png'; 
            newCheckOutState.restaurantCustomTipButtonLogoUrl = process.env.REACT_APP_CUSTOM_TIP_LOGO_URL + '/' + r.location.id + '.png'; 
            newCheckOutState.checkInId = checkInId;
            newCheckOutState.sentRating = false;
            newCheckOutState.digitalServiceFee = r.location.configuration.digital_service_fee;
            newCheckOutState.checkInUrl = document.location.href;
            newCheckOutState.paymentMethodsAccepted = r.location.configuration.payment_methods_accepted;
            newCheckOutState.paymentGateway = r.location.configuration.payment_gateway;
            newCheckOutState.paymentGatewayConnector = r.location.configuration.payment_gateway_connector;
            newCheckOutState.posType = r.location.configuration.pos_type;
            newCheckOutState.pmsType = r.location.configuration.pms_type;
            newCheckOutState.stripeApiKey = r.location.configuration.stripe_api_key;
            newCheckOutState.stripeAccountId = r.location.configuration.stripe_account_id;
            newCheckOutState.menuUrl = r.location.configuration.menu_url;
            newCheckOutState.spreedlyEnvKey = r.location.configuration.spreedly_env_key;
            newCheckOutState.useCaptcha = r.location.configuration.use_captcha;
            newCheckOutState.feedbackType = r.location.configuration.feedback_type;
            newCheckOutState.akiraSurveyUrl = r.location.configuration.akira_survey_url;
            newCheckOutState.restaurantApiKey = r.location.api_key;
            newCheckOutState.skin = r.location.skin;
            
            if (r.location.is_demo) {
                newCheckOutState.checkOutType = CheckOutType.Demo
                newCheckOutState.paymentGateway = PaymentGateway.Demo
            }
            
            checkOutState.setState(newCheckOutState);

            if (r.location.is_demo) {
                initiateDemoCheckOut();
            }
            else {
                initiateCheckout(cancelTokenSource);
            }
        }
        else {
            setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
            setErrorDialogOpen(true);
            setLoadError(true);
        }
    }

    const initiateCheckout = async (cancelTokenSource: CancelTokenSource) => {
        var checkOutType: CheckOutType = parseInt(getUrlParameter(history.location.search, 'c'));
        let url: string | undefined = process.env.REACT_APP_CHECKOUT_API_URL + "/location/" + checkOutState.state.restaurantId + "/checkout/web"
        let request: WebCheckOutRequest | null = null;

        if (checkOutType === CheckOutType.TextToPay) {
            checkOutType = CheckOutType.ScanReceiptToPay;
        }

        setCheckOutType(checkOutType);

        let userId: number | null = null;

        if (cookies.userId !== null && cookies.userId !== undefined) {
            userId = parseInt(cookies.userId);
        }

        let shareParam = getUrlParameter(history.location.search, 's');
        if (shareParam !== null && shareParam !== undefined && shareParam !== '') {
            if (cookies.userId === null || cookies.userId === undefined) {
                isShare = true;
            }
        }

        let validLink: boolean = true;

        if (checkOutType === CheckOutType.ScanToPay) {
            const tableId: string = getUrlParameter(history.location.search, 't');

            request = {
                checkin_id: null,
                table_id: tableId,
                user_id: userId,
                check_external_id: null,
                checkout_type: CheckOutType.ScanToPay,
            };

            
        }
        else if (checkOutType === CheckOutType.ScanReceiptToPay) {
            const externalCheckId: string = getUrlParameter(history.location.search, 't');

            request = {
                checkin_id: null,
                table_id: null,
                check_external_id: externalCheckId,
                user_id: userId,
                checkout_type: CheckOutType.ScanReceiptToPay,
            };
        }
        else if (checkOutType === CheckOutType.GrabNGo) {
            const checkInId: string = getUrlParameter(history.location.search, 'i');

            request = {
                checkin_id: checkInId,
                table_id: null,
                user_id: userId,
                check_external_id: null,
                checkout_type: CheckOutType.GrabNGo,
            };
        }
        else if (checkOutType === CheckOutType.Demo) {
            const checkInId: string = getUrlParameter(history.location.search, 'i');

            request = {
                checkin_id: checkInId,
                table_id: null,
                user_id: userId,
                check_external_id: null,
                checkout_type: CheckOutType.Demo,
            };
        }
        else {
            validLink = false;
            setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
            setErrorDialogOpen(true);
            setLoadError(true);
            setLoaded(true);
        }

        if (validLink) {

            const headers = {
                'X-API-Key': checkOutState.state.restaurantApiKey!!,
                'location_id': checkOutState.state.restaurantId!!
            }

            axios.post(url!!, request!!, { headers, cancelToken: cancelTokenSource.token })
            .then(function(response) {
                let r = response.data as WebCheckOutResponse;

                const newCheckOutState: CheckOutState = checkOutState.state;
                const newUserState: UserState = userState.state;

                if (r.success) {

                    if (checkOutType !== CheckOutType.Demo) {
                        if (cookies.userId === null || cookies.userId === undefined) {
                            setCookie("userId", r.user_id);
                            newUserState.userId = r.user_id;
                        }
                        else {
                            newUserState.userId = parseInt(cookies.userId);
                        }
                    }
                    else {
                        newUserState.userId = r.user_id;
                    }
                    
                    newUserState.userIdentifier = r.user_identifier;

                    if (locale !== undefined) {
                        newUserState.locale = locale
                    }

                    userState.setState(newUserState);

                    newCheckOutState.tableNumber = r.table_number;
                    newCheckOutState.tableId = r.table_id;
                    newCheckOutState.checkInId = checkInId;
                    newCheckOutState.checks = r.checks;
                    newCheckOutState.checkOutType = checkOutType;
                    newCheckOutState.shareCheckInUrl = r.share_checkin_url;
                    
                    if (checkOutType === CheckOutType.ScanReceiptToPay) {
                        const externalCheckId: string = getUrlParameter(history.location.search, 't');
                        newCheckOutState.receiptCheckExternalId = externalCheckId;
                    }
                    
                    checkOutState.setState(newCheckOutState);

                    if (checkOutType === CheckOutType.ScanReceiptToPay && r.checks.length > 0 && checkOutState.state.feedbackType !== FeedbackType.Akira) {
                        history.push({
                            pathname: '/checkout/check',
                            state: { 
                                checkSummary: r.checks[0],
                            }
                        }); 
                    }
                    else {
                        setChecks(r.checks);
                        setSignalRLoad(true);
                    }

                    if (checkOutType === CheckOutType.ScanReceiptToPay && checkOutState.state.feedbackType !== FeedbackType.Akira) {
                        if (r.checks.length === 0) {
                            setErrorMessage(String_CheckOut_NoOpenChecks_ScanReceiptToPay.find(s => s.key === userState.state.locale)!!.value);
                            setErrorDialogOpen(true);
                            setLoadError(true);
                        }
                        else {
                            setLoaded(true);
                        }
                    }
                    else {
                        setLoaded(true);
                    }
                }
                else {
                    if (checkOutType === CheckOutType.ScanReceiptToPay) {
                        setErrorMessage(String_CheckOut_NoOpenChecks_ScanReceiptToPay.find(s => s.key === userState.state.locale)!!.value);
                        setErrorDialogOpen(true);
                        setLoadError(true);
                    }
                    else {
                        setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                        setErrorDialogOpen(true);
                        setLoadError(true);
                    }
                }
            })
            .catch(function(error) {
                if (error.response) {
                    setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                }
                else {
                    setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                }

                setErrorDialogOpen(true);
                setLoadError(true);
                setLoaded(true);
            });      
        }  
    };

    const initiateDemoCheckOut = () => {
        const newCheckOutState: CheckOutState = checkOutState.state;
     
        var check: CheckSummary = loadDemoCheckSummaryData()

        newCheckOutState.tableNumber = "5";
        newCheckOutState.tableId = "5";
        newCheckOutState.checks = [check];

        checkOutState.setState(newCheckOutState);

        history.push({
            pathname: '/checkout/check',
            state: { 
                checkSummary: check,
            }
        }); 
    }

    const handleLeftButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        if (checkOutType !== CheckOutType.Demo) {
            if (checkOutState.state.feedbackType === FeedbackType.Akira) {
                window.location.href = checkOutState.state.akiraSurveyUrl!!;
            }
            else if (checkOutState.state.menuUrl !== null) {
                window.location.href = checkOutState.state.menuUrl!!;
            }
        }
        else {
            setCheckout(false);
        }        
    }

    const handleRightButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        if (checks !== null && checks !== undefined && checks.length > 0) {
            if (checks.length === 1) {
                history.push({
                    pathname: '/checkout/check',
                    state: { 
                        checkSummary: checks[0],
                    }
                });          
            }
            else {
                history.push({
                    pathname: '/checkout/multiplechecks',
                    state: { 
                        checks: checks,
                    }
                }); 
            }
        }
        else {
            if (checkOutType === CheckOutType.TextToPay) {
                setErrorMessage(String_CheckOut_NoOpenChecks_TextToPay.find(s => s.key === userState.state.locale)!!.value);
            }
            else {
                setErrorMessage(String_CheckOut_NoOpenChecks_ScanToPay.find(s => s.key === userState.state.locale)!!.value);
            }
            setErrorDialogOpen(true);
        }
    }

    const checkOutButtonProps: FullWidthButtonProps = {
        disabled: false,
        label: String_CheckOut_CheckOutButton.find(s => s.key === userState.state.locale)!!.value,
        alternateColor: false,
        size: FullWidthButtonSize.Large,
        onClickHandler: handleRightButtonClick,
    }

    const splitButtonProps: SplitButtonProps = {
        leftLabel: checkOutState.state.feedbackType === FeedbackType.Akira ? 
            String_CheckOut_FeedbackButton.find(s => s.key === userState.state.locale)!!.value :
            String_CheckOut_ViewMenuButton.find(s => s.key === userState.state.locale)!!.value,
        rightLabel: String_CheckOut_CheckOutButton.find(s => s.key === userState.state.locale)!!.value,
        leftDisabled: false,
        rightDisabled: false,
        showIcons: false,
        useForwardIcon: false,
        useBackIcon: false,
        onLeftClickHandler: handleLeftButtonClick,
        onRightClickHandler: handleRightButtonClick,
    }

    const handleBackButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        setCheckout(true);
    }

    const fullWidthButtonProps: FullWidthButtonProps = {
        disabled: false,
        label: String_System_Cancel.find(s => s.key === userState.state.locale)!!.value,
        alternateColor: false,
        size: FullWidthButtonSize.Large,
        onClickHandler: handleBackButtonClick,
    }

    const handleErrorDialogClose = (event: React.MouseEvent<HTMLElement>) => {
        setErrorDialogOpen(false);

        window.location.reload();
    }

    const errorDialogProps: ErrorDialogProps = {
        open: errorDialogOpen,
        message: errorMessage,
        tryAgain: true,
        onCloseHandler: handleErrorDialogClose,
    }

    const signalRInitializedHandler = () => {
        setSignalRInitialized(true);
    }

    const signalRNotificationReceivedHandler = (type: CheckNotificationType, amount: number) => {
        if (type === CheckNotificationType.AmountClaimed) {

        }
        else if (type === CheckNotificationType.PaymentCompleted) {

        }
        else if (type === CheckNotificationType.CheckClosed) {
            getLocation(axios.CancelToken.source());
        }
        else if (type === CheckNotificationType.ClaimExpired) {
            
        }
    }
    
    return (
        <div className={isPortrait === true ? classes.root : classes.rootLandscape}>

            {loaded && !loadError && checkOut &&
                <div className={isPortrait === true ? classes.details : classes.detailsLandscape}>
                    <div>
                        <div className={classes.instructionContainer}>
                            <Typography variant="h4" className={classes.instructionText}>
                                {checkOutState.state.feedbackType === FeedbackType.Akira &&
                                    String_CheckOut_Instruction_With_Feedback.find(s => s.key === userState.state.locale)!!.value
                                }
                                {checkOutState.state.feedbackType !== FeedbackType.Akira &&
                                    String_CheckOut_Instruction.find(s => s.key === userState.state.locale)!!.value
                                }
                            </Typography>
                        </div>
                        <div className={classes.gridContainer}>
                            <div className={classes.grid}>
                                {checkOutType === CheckOutType.TextToPay || checkOutType === CheckOutType.GrabNGo &&
                                    <Typography variant='h5' className={classes.label}>
                                        {String_CheckOut_PhoneLabel.find(s => s.key === userState.state.locale)!!.value} 
                                    </Typography>
                                }

                                {checkOutType === CheckOutType.TextToPay || checkOutType === CheckOutType.GrabNGo &&
                                    <Typography variant='h5' className={classes.value}>
                                        {FormatPhoneNumber(userState.state.userIdentifier === null ? '' : userState.state.userIdentifier)}
                                    </Typography>
                                }   

                                {checkOutType !== CheckOutType.GrabNGo && checkOutState.state.tableId !== null &&
                                    <Typography variant='h5' className={classes.label}>
                                        {String_CheckOut_TableLabel.find(s => s.key === userState.state.locale)!!.value}
                                    </Typography>
                                }

                                {checkOutType !== CheckOutType.GrabNGo &&
                                    <Typography variant='h5' className={classes.value}>
                                        {checkOutState.state.tableNumber}
                                    </Typography>
                                }

                            </div>
                        </div>
                        <div className={classes.instruction2Container}>
                            <Typography variant='h6'>
                                {checkOutState.state.feedbackType === FeedbackType.Akira &&
                                    String_CheckOut_Instruction_Sub_With_Feedback.find(s => s.key === userState.state.locale)!!.value
                                }
                                {checkOutState.state.feedbackType !== FeedbackType.Akira &&
                                    String_CheckOut_Instruction_Sub.find(s => s.key === userState.state.locale)!!.value
                                }
                            </Typography>
                        </div>
                    </div>
                </div>
            }

            {loaded && !loadError && !checkOut && checkOutType === CheckOutType.Demo &&
                <div className={isPortrait === true ? classes.detailsIFrame : classes.detailsIFrameLandscape}>
                    <img src={DemoMenu} className={classes.demoMenu}></img>
                </div>
            }

            {loaded && !loadError && 
                <div className={isPortrait ? classes.footerButtons : classes.footerButtonsLandscape}>

                    <SplitButtons
                        leftLabel={splitButtonProps.leftLabel}
                        rightLabel={splitButtonProps.rightLabel}
                        leftDisabled={splitButtonProps.leftDisabled}
                        rightDisabled={splitButtonProps.rightDisabled}
                        showIcons={splitButtonProps.showIcons}
                        useForwardIcon={splitButtonProps.useForwardIcon}
                        useBackIcon={splitButtonProps.useBackIcon}
                        onLeftClickHandler={splitButtonProps.onLeftClickHandler}
                        onRightClickHandler={splitButtonProps.onRightClickHandler} />

                    {isPortrait &&
                        <div className={classes.logoContainer}>
                            <img src={LogoImage}></img>
                        </div>
                    }

                </div>
            }
            
            {!loaded && !loadError &&
                <div className={classes.loadingContainer}>
                    {!loaded &&
                        <Loader />                    
                    }
                </div>
            }

            <ErrorDialog 
                open={errorDialogProps.open}
                message={errorDialogProps.message}
                tryAgain={errorDialogProps.tryAgain}
                onCloseHandler={errorDialogProps.onCloseHandler} />

            {checkOutState.state.checks !== null && 
                <SignalR 
                    oldChecks={oldChecks}
                    messageType={CheckMessageType.Subscribe}
                    load={signalRLoad}
                    refreshCheck={false}
                    onNotificationReceived={signalRNotificationReceivedHandler}
                    onInitialized={signalRInitializedHandler} />
            }

         </div>
    );
};

export default CheckOut;